module.exports = __webpack_public_path__ + "7bc8931b9792731608e2f228830aa4a8.png";